import { Box, Button, Card, CardContent, CardHeader, Chip, Stack, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../stores/hooks";
import { useState } from "react";
import { NLCInfo, OutputTableInfo } from "../../data/interfaces/sharedmodels";
import { reset as magneticReset } from "../../stores/magneticslice";
import { reset as ItsoReset } from "../../stores/itsoslice";
import { setcurrentmenu } from "../../stores/menuslice";
import { useNavigate } from "react-router-dom";
import { updateBuildTableStep as updateMagneticBuildTableStep} from "../../stores/magneticslice";
import { updateBuildTableStep as updateItsoBuildTableStep } from "../../stores/itsoslice";





export default function BuildSummary({ parent }: { parent: string }) {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const selectedOutputTables = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedOutputTables; }
        else { return state.itsoReducer.selectedOutputTables; }
    });

    const selectedOutputNlcs = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedOutputNlcs; }
        else { return state.itsoReducer.selectedOutputNlcs; }
    });
    const jobDescription = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.jobDescription; }
        else { return state.itsoReducer.jobDescription; }
    });

    const currentJobNumber = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.currentJobNumber; }
        else { return state.itsoReducer.currentJobNumber; }
    });
    const handleOk = () => {
        if (parent === 'magnetic') {
            dispatch(magneticReset());
            dispatch(updateMagneticBuildTableStep(0));
        }
        else {
            dispatch(ItsoReset());
            dispatch(updateItsoBuildTableStep(0));
        }
        
    }

    const handleGotoProgress=()=>{
        if (parent === 'magnetic') {
            dispatch(magneticReset());
        }
        else {
            dispatch(ItsoReset());
        }
        navigate('/jobs');
    }

    return (
        <Box>
            <Card>
                <CardHeader title={"Build Summary - " + currentJobNumber}></CardHeader>
                <CardContent>
                    <Stack spacing={2}>
                        {selectedOutputTables.findIndex(a => a.IsGlobal) > -1 ?
                            <Box>
                                Global Tables :
                                {selectedOutputTables.filter(a => a.IsGlobal).map((table: OutputTableInfo) => {
                                    return (
                                        <Chip key={table.Id} label={table.Name + ' - ' + table.Description} variant="outlined"
                                            sx={{ m: 0.5, borderColor: 'primary.main', color: 'primary.main' }} />
                                    )
                                })

                                }
                            </Box> : null}

                        {selectedOutputTables.findIndex(a => !a.IsGlobal) > -1 ? <Box>
                            <Box>
                                Station Specific Tables :
                                {selectedOutputTables.filter(a => !a.IsGlobal).map((table: OutputTableInfo) => {
                                    return (
                                        <Chip key={table.Id} label={table.Name + ' - ' + table.Description} variant="outlined"
                                            sx={{ m: 0.5, borderColor: 'primary.main', color: 'primary.main' }} />
                                    )
                                })

                                }
                            </Box>
                            <Box sx={{mt:2}}>
                                Stations :
                                {selectedOutputNlcs.map((nlc: NLCInfo) => {
                                    return (
                                        <Chip key={nlc.Id} label={nlc.NLC + ' - ' + nlc.StationName}
                                            sx={{ m: 0.5, backgroundColor: 'primary.main', color: 'secondary.main' }} />
                                    )
                                })

                                }
                            </Box>
                        </Box> : null}
                        <Box >
                            <Typography variant="body1">Description : {jobDescription}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button variant="contained" onClick={handleOk}>Ok</Button>
                            <Button variant="outlined" sx={{ml:1}} onClick={handleGotoProgress}>Check Progress</Button>
                        </Box>
                    </Stack>

                </CardContent>
            </Card>
        </Box>
    )
}